module.exports = __webpack_public_path__ + "images/8c565b7b.03_icon_起点.png";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/static/images/03_icon_起点.png
// module id = 343
// module chunks = 96 99